import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';
import Footer from '../home/components/Footer';

const comuni = [
  // Sede - Paderno Franciacorta
  { nome: 'Paderno Franciacorta', zona: 'Sede Operativa', distanza: '0 km' },

  // Franciacorta (0-10 km dalla sede)
  { nome: 'Rodengo Saiano', zona: 'Franciacorta', distanza: '~3 km' },
  { nome: 'Passirano', zona: 'Franciacorta', distanza: '~4 km' },
  { nome: 'Castegnato', zona: 'Franciacorta', distanza: '~5 km' },
  { nome: 'Ospitaletto', zona: 'Franciacorta', distanza: '~5 km' },
  { nome: "Provaglio d'Iseo", zona: 'Franciacorta', distanza: '~6 km' },
  { nome: 'Ome', zona: 'Franciacorta', distanza: '~5 km' },
  { nome: 'Gussago', zona: 'Franciacorta', distanza: '~5 km' },
  { nome: 'Cellatica', zona: 'Franciacorta', distanza: '~7 km' },
  { nome: 'Cazzago San Martino', zona: 'Franciacorta', distanza: '~6 km' },
  { nome: 'Erbusco', zona: 'Franciacorta', distanza: '~8 km' },
  { nome: 'Adro', zona: 'Franciacorta', distanza: '~9 km' },
  { nome: 'Corte Franca', zona: 'Franciacorta', distanza: '~8 km' },
  { nome: 'Capriolo', zona: 'Franciacorta', distanza: '~10 km' },
  { nome: 'Monticelli Brusati', zona: 'Franciacorta', distanza: '~4 km' },
  { nome: 'Cologne', zona: 'Franciacorta', distanza: '~10 km' },

  // Brescia e Hinterland (5-15 km dalla sede)
  { nome: 'Brescia', zona: 'Brescia e Hinterland', distanza: '~12 km' },
  { nome: 'Collebeato', zona: 'Brescia e Hinterland', distanza: '~8 km' },
  { nome: 'Concesio', zona: 'Brescia e Hinterland', distanza: '~10 km' },
  { nome: 'Bovezzo', zona: 'Brescia e Hinterland', distanza: '~10 km' },
  { nome: 'Roncadelle', zona: 'Brescia e Hinterland', distanza: '~10 km' },
  { nome: 'Castel Mella', zona: 'Brescia e Hinterland', distanza: '~13 km' },
  { nome: 'Flero', zona: 'Brescia e Hinterland', distanza: '~14 km' },
  { nome: 'San Zeno Naviglio', zona: 'Brescia e Hinterland', distanza: '~13 km' },
  { nome: 'Borgosatollo', zona: 'Brescia e Hinterland', distanza: '~15 km' },
  { nome: 'Rezzato', zona: 'Brescia e Hinterland', distanza: '~17 km' },
  { nome: 'Botticino', zona: 'Brescia e Hinterland', distanza: '~16 km' },
  { nome: 'Capriano del Colle', zona: 'Brescia e Hinterland', distanza: '~14 km' },
  { nome: 'Torbole Casaglia', zona: 'Brescia e Hinterland', distanza: '~11 km' },
  { nome: 'Travagliato', zona: 'Brescia e Hinterland', distanza: '~9 km' },
  { nome: 'Castenedolo', zona: 'Brescia e Hinterland', distanza: '~18 km' },

  // Lago d'Iseo (8-15 km dalla sede)
  { nome: 'Iseo', zona: "Lago d'Iseo", distanza: '~10 km' },
  { nome: 'Sulzano', zona: "Lago d'Iseo", distanza: '~13 km' },
  { nome: 'Sale Marasino', zona: "Lago d'Iseo", distanza: '~15 km' },
  { nome: 'Paratico', zona: "Lago d'Iseo", distanza: '~13 km' },
  { nome: 'Sarnico', zona: "Lago d'Iseo", distanza: '~14 km' },
  { nome: 'Marone', zona: "Lago d'Iseo", distanza: '~17 km' },

  // Valtrompia (12-25 km dalla sede)
  { nome: 'Villa Carcina', zona: 'Valtrompia', distanza: '~12 km' },
  { nome: 'Sarezzo', zona: 'Valtrompia', distanza: '~15 km' },
  { nome: 'Lumezzane', zona: 'Valtrompia', distanza: '~18 km' },
  { nome: 'Gardone Val Trompia', zona: 'Valtrompia', distanza: '~20 km' },
  { nome: 'Marcheno', zona: 'Valtrompia', distanza: '~22 km' },
  { nome: 'Caino', zona: 'Valtrompia', distanza: '~14 km' },

  // Bassa Bresciana (15-30 km dalla sede)
  { nome: 'Rovato', zona: 'Bassa Bresciana Ovest', distanza: '~10 km' },
  { nome: 'Chiari', zona: 'Bassa Bresciana Ovest', distanza: '~15 km' },
  { nome: "Palazzolo sull'Oglio", zona: 'Bassa Bresciana Ovest', distanza: '~16 km' },
  { nome: 'Pontoglio', zona: 'Bassa Bresciana Ovest', distanza: '~18 km' },
  { nome: 'Coccaglio', zona: 'Bassa Bresciana Ovest', distanza: '~11 km' },
  { nome: 'Rudiano', zona: 'Bassa Bresciana Ovest', distanza: '~17 km' },
  { nome: 'Castrezzato', zona: 'Bassa Bresciana Ovest', distanza: '~12 km' },
  { nome: 'Comezzano-Cizzago', zona: 'Bassa Bresciana Ovest', distanza: '~13 km' },
  { nome: 'Berlingo', zona: 'Bassa Bresciana Ovest', distanza: '~8 km' },
  { nome: 'Lograto', zona: 'Bassa Bresciana Ovest', distanza: '~10 km' },
  { nome: 'Maclodio', zona: 'Bassa Bresciana Ovest', distanza: '~11 km' },

  // Bassa Bresciana Sud (18-30 km dalla sede)
  { nome: 'Azzano Mella', zona: 'Bassa Bresciana Sud', distanza: '~16 km' },
  { nome: 'Poncarale', zona: 'Bassa Bresciana Sud', distanza: '~14 km' },
  { nome: 'Montirone', zona: 'Bassa Bresciana Sud', distanza: '~16 km' },
  { nome: 'Bagnolo Mella', zona: 'Bassa Bresciana Sud', distanza: '~20 km' },
  { nome: 'Ghedi', zona: 'Bassa Bresciana Sud', distanza: '~23 km' },
  { nome: 'Leno', zona: 'Bassa Bresciana Sud', distanza: '~25 km' },
  { nome: 'Manerbio', zona: 'Bassa Bresciana Sud', distanza: '~22 km' },
  { nome: 'Dello', zona: 'Bassa Bresciana Sud', distanza: '~18 km' },
  { nome: 'Mairano', zona: 'Bassa Bresciana Sud', distanza: '~16 km' },
  { nome: 'Brandico', zona: 'Bassa Bresciana Sud', distanza: '~13 km' },

  // Entroterra Gardesano (20-30 km dalla sede)
  { nome: 'Montichiari', zona: 'Entroterra Gardesano', distanza: '~27 km' },
  { nome: 'Calcinato', zona: 'Entroterra Gardesano', distanza: '~28 km' },
  { nome: 'Gavardo', zona: 'Entroterra Gardesano', distanza: '~25 km' },
];

const zone = [
  'Tutte',
  'Sede Operativa',
  'Franciacorta',
  'Brescia e Hinterland',
  "Lago d'Iseo",
  'Valtrompia',
  'Bassa Bresciana Ovest',
  'Bassa Bresciana Sud',
  'Entroterra Gardesano',
];

const zoneMapInfo = [
  {
    nome: 'Sede Operativa',
    icona: 'ri-home-gear-line',
    colore: '#E31E24',
    raggio: '0 km',
    descrizione: 'Paderno Franciacorta',
  },
  {
    nome: 'Franciacorta',
    icona: 'ri-goblet-line',
    colore: '#D4A574',
    raggio: '0-10 km',
    descrizione: '16 comuni della zona vinicola',
  },
  {
    nome: 'Brescia e Hinterland',
    icona: 'ri-building-line',
    colore: '#E31E24',
    raggio: '5-18 km',
    descrizione: 'Brescia città e comuni limitrofi',
  },
  {
    nome: "Lago d'Iseo",
    icona: 'ri-water-flash-line',
    colore: '#2E86AB',
    raggio: '10-17 km',
    descrizione: 'Sebino bresciano e bergamasco',
  },
  {
    nome: 'Valtrompia',
    icona: 'ri-landscape-line',
    colore: '#4A7C59',
    raggio: '12-22 km',
    descrizione: 'Valle industriale a nord',
  },
  {
    nome: 'Bassa Bresciana Ovest',
    icona: 'ri-plant-line',
    colore: '#8B6914',
    raggio: '8-18 km',
    descrizione: 'Pianura a sud-ovest',
  },
  {
    nome: 'Bassa Bresciana Sud',
    icona: 'ri-seedling-line',
    colore: '#6B8E23',
    raggio: '13-25 km',
    descrizione: 'Pianura a sud',
  },
  {
    nome: 'Entroterra Gardesano',
    icona: 'ri-sun-line',
    colore: '#D4763A',
    raggio: '25-28 km',
    descrizione: 'Verso il Lago di Garda',
  },
];

export default function ZoneServite() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [zonaSelezionata, setZonaSelezionata] = useState('Tutte');
  const [searchTerm, setSearchTerm] = useState('');

  useSEO({
    title:
      'Zone Servite Paderno Franciacorta e Provincia di Brescia | Meccanico a Domicilio | Metamorfosi Preparazioni',
    description:
      "Meccanico a domicilio con sede a Paderno Franciacorta. Servizio in tutta la Franciacorta, Brescia, Lago d'Iseo, Valtrompia e Bassa Bresciana entro 30 km.",
    keywords:
      'meccanico Paderno Franciacorta, meccanico a domicilio Franciacorta, zone servite Brescia, tagliandi Iseo, meccanico Franciacorta, officina mobile Brescia provincia, manutenzione auto Lago d\'Iseo',
    canonical: '/zone-servite',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Meccanico a Domicilio - Zone Servite',
      provider: {
        '@type': 'AutoRepair',
        name: 'Metamorfosi Preparazioni',
        telephone: '+39 351 831 2394',
        email: 'metamorfosi.preparazioni@gmail.com',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Paderno Franciacorta',
          addressRegion: 'BS',
          addressCountry: 'IT',
        },
      },
      areaServed: comuni.map((c) => ({
        '@type': 'City',
        name: c.nome,
        containedInPlace: {
          '@type': 'AdministrativeArea',
          name: 'Provincia di Brescia',
        },
      })),
      serviceType: 'Manutenzione Auto e Moto a Domicilio',
    },
  });

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const comuniFiltrati = comuni.filter((comune) => {
    const matchZona =
      zonaSelezionata === 'Tutte' || comune.zona === zonaSelezionata;
    const matchSearch = comune.nome
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    return matchZona && matchSearch;
  });

  const comuniPerZona = zone.slice(1).map((zona) => ({
    zona,
    comuni: comuni.filter((c) => c.zona === zona),
  }));

  return (
    <div className="min-h-screen bg-white">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black shadow-lg">
        <div className="w-full px-4 sm:px-6 lg:px-12">
          <div className="flex items-center justify-between h-16 sm:h-18 md:h-20">
            <Link to="/" className="flex-shrink-0">
              <img 
                src="https://static.readdy.ai/image/26c3401126eecf15eb2286ded28883ff/289e4af9c1f47a64ff4db8c7e8c98e4a.jpeg" 
                alt="Metamorfosi Preparazioni Logo" 
                className="h-10 sm:h-12 md:h-14 w-auto"
              />
            </Link>
            <Link 
              to="/" 
              className="flex items-center text-white hover:text-[#E31E24] transition-colors duration-300 cursor-pointer group relative"
              title="Torna alla Home"
            >
              <i className="ri-home-4-line text-2xl"></i>
              <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                Torna alla Home
              </span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-20 pb-16 md:pt-28 md:pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/87a33f2a404126efeda6a619741f6084.jpg"
            alt="Franciacorta e Provincia di Brescia"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-[#E31E24]/20 border border-[#E31E24]/30 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-map-pin-line text-[#E31E24]"></i>
              <span className="text-white text-sm font-medium">
                Sede: Paderno Franciacorta
              </span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6">
              Zona Operativa
            </h1>
            <p className="text-lg sm:text-xl text-white/90 mb-6 md:mb-8 leading-relaxed">
              Offro servizio di <strong>meccanico a domicilio</strong> con sede
              a <strong>Paderno Franciacorta</strong>. <strong>Vengo direttamente da te</strong> in un <strong>raggio di 30 km</strong>: Franciacorta, Brescia,
              Lago d&apos;Iseo, Valtrompia e Bassa Bresciana. Lavoro a casa tua, nel tuo garage o parcheggio.
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="tel:+393518312394"
                className="inline-flex items-center px-6 py-3 bg-[#E31E24] text-white font-semibold rounded-lg hover:bg-[#c41a1f] transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                Chiamami
              </a>
              <a
                href="https://wa.me/393518312394"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-white text-black font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2 text-[#25D366]"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-6 md:py-8 bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="flex flex-col gap-4">
            <div className="relative w-full md:w-96">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Cerca il tuo comune..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-lg border border-gray-300 focus:border-[#E31E24] focus:ring-2 focus:ring-[#E31E24]/20 outline-none transition-all text-sm"
              />
            </div>

            <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 sm:mx-0 sm:px-0 sm:flex-wrap scrollbar-hide">
              {zone.map((z) => (
                <button
                  key={z}
                  onClick={() => setZonaSelezionata(z)}
                  className={`px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap flex-shrink-0 ${
                    zonaSelezionata === z
                      ? 'bg-[#E31E24] text-white'
                      : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                  }`}
                >
                  {z}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Mappa Interattiva */}
      <section className="py-10 md:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
              <i className="ri-map-2-line text-[#E31E24] mr-2"></i>
              Mappa della Zona Operativa
            </h2>
            <p className="text-gray-600 text-sm max-w-2xl mx-auto">
              Copro un <strong>raggio di 30 km da Paderno Franciacorta</strong>.
              Clicca sulla legenda per esplorare le zone di copertura del
              servizio meccanico a domicilio.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2 rounded-xl overflow-hidden shadow-lg border border-gray-200">
              <div className="relative w-full h-[400px] md:h-[500px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d140000!2d10.07!3d45.58!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sit!4v1700000000001!5m2!1sit!2sit"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mappa zone servite da Paderno Franciacorta meccanico a domicilio provincia Brescia"
                  className="w-full h-full"
                ></iframe>
                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm rounded-lg px-4 py-2 shadow-md border border-gray-100">
                  <div className="flex items-center gap-2">
                    <span className="w-3 h-3 rounded-full bg-[#E31E24] animate-pulse"></span>
                    <span className="text-sm font-semibold text-gray-800">
                      Raggio 30 km da Paderno F.corta
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-gray-50 rounded-xl p-5 border border-gray-200 h-full">
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <i className="ri-list-check text-[#E31E24]"></i>
                  Legenda Zone
                </h3>
                <div className="space-y-3 max-h-[420px] overflow-y-auto pr-1 custom-scrollbar">
                  {zoneMapInfo.map((zona) => (
                    <button
                      key={zona.nome}
                      onClick={() => {
                        const matchingZone = zone.find((z) => z === zona.nome);
                        if (matchingZone) {
                          setZonaSelezionata(matchingZone);
                        }
                        const gridSection = document.getElementById(
                          'comuni-grid'
                        );
                        if (gridSection) {
                          gridSection.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                          });
                        }
                      }}
                      className="w-full flex items-start gap-3 p-3 rounded-lg bg-white border border-gray-100 hover:border-[#E31E24]/40 hover:shadow-sm transition-all duration-300 cursor-pointer text-left group"
                    >
                      <div
                        className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110"
                        style={{ backgroundColor: `${zona.colore}15` }}
                      >
                        <i
                          className={`${zona.icona} text-lg`}
                          style={{ color: zona.colore }}
                        ></i>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between gap-2">
                          <span className="text-sm font-semibold text-gray-800 truncate">
                            {zona.nome}
                          </span>
                          <span
                            className="text-xs font-medium px-2 py-0.5 rounded-full flex-shrink-0"
                            style={{
                              backgroundColor: `${zona.colore}15`,
                              color: zona.colore,
                            }}
                          >
                            {zona.raggio}
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5">
                          {zona.descrizione}
                        </p>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Indicatori raggio */}
          <div className="mt-6 md:mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
            <div className="bg-[#D4A574]/5 rounded-xl p-4 text-center border border-[#D4A574]/10">
              <div className="w-12 h-12 rounded-full bg-[#D4A574]/10 flex items-center justify-center mx-auto mb-2">
                <span className="text-[#D4A574] font-bold text-lg">10</span>
              </div>
              <p className="text-xs font-semibold text-gray-800">
                Entro 10 km
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Franciacorta, Lago d&apos;Iseo
              </p>
            </div>
            <div className="bg-[#E31E24]/5 rounded-xl p-4 text-center border border-[#E31E24]/10">
              <div className="w-12 h-12 rounded-full bg-[#E31E24]/10 flex items-center justify-center mx-auto mb-2">
                <span className="text-[#E31E24] font-bold text-lg">20</span>
              </div>
              <p className="text-xs font-semibold text-gray-800">
                Entro 20 km
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Brescia, Valtrompia, Bassa
              </p>
            </div>
            <div className="bg-[#2E86AB]/5 rounded-xl p-4 text-center border border-[#2E86AB]/10">
              <div className="w-12 h-12 rounded-full bg-[#2E86AB]/10 flex items-center justify-center mx-auto mb-2">
                <span className="text-[#2E86AB] font-bold text-lg">30</span>
              </div>
              <p className="text-xs font-semibold text-gray-800">
                Entro 30 km
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Entroterra Gardesano, Leno
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comuni Grid */}
      <section id="comuni-grid" className="py-10 md:py-16 scroll-mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          {zonaSelezionata === 'Tutte' && searchTerm === '' ? (
            <div className="space-y-10 md:space-y-12">
              {comuniPerZona.map(({ zona, comuni: comuniZona }) => (
                <div key={zona}>
                  <div className="flex flex-wrap items-center gap-3 md:gap-4 mb-4 md:mb-6">
                    <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                      {zona}
                    </h2>
                    <span className="px-3 py-1 bg-[#E31E24]/10 text-[#E31E24] text-sm font-medium rounded-full">
                      {comuniZona.length}{' '}
                      {comuniZona.length === 1 ? 'comune' : 'comuni'}
                    </span>
                  </div>
                  <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-3">
                    {comuniZona.map((comune) => (
                      <div
                        key={comune.nome}
                        className="bg-white border border-gray-200 rounded-lg px-4 py-3 hover:border-[#E31E24] hover:shadow-md transition-all duration-300 cursor-default"
                      >
                        <div className="flex items-center gap-2">
                          <i
                            className={`${
                              comune.zona === 'Sede Operativa'
                                ? 'ri-home-gear-line'
                                : 'ri-map-pin-line'
                            } text-[#E31E24] text-sm`}
                          ></i>
                          <span className="text-sm font-medium text-gray-800 truncate">
                            {comune.nome}
                          </span>
                        </div>
                        <span className="text-xs text-gray-500 mt-1 block">
                          {comune.distanza}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div>
              <div className="flex flex-wrap items-center gap-3 md:gap-4 mb-4 md:mb-6">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                  {zonaSelezionata !== 'Tutte'
                    ? zonaSelezionata
                    : 'Risultati ricerca'}
                </h2>
                <span className="px-3 py-1 bg-[#E31E24]/10 text-[#E31E24] text-sm font-medium rounded-full">
                  {comuniFiltrati.length} comuni
                </span>
              </div>
              {comuniFiltrati.length > 0 ? (
                <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-3">
                  {comuniFiltrati.map((comune) => (
                    <div
                      key={comune.nome}
                      className="bg-white border border-gray-200 rounded-lg px-4 py-3 hover:border-[#E31E24] hover:shadow-md transition-all duration-300 cursor-default"
                    >
                      <div className="flex items-center gap-2">
                        <i
                          className={`${
                            comune.zona === 'Sede Operativa'
                              ? 'ri-home-gear-line'
                              : 'ri-map-pin-line'
                          } text-[#E31E24] text-sm`}
                        ></i>
                        <span className="text-sm font-medium text-gray-800 truncate">
                          {comune.nome}
                        </span>
                      </div>
                      <div className="flex items-center justify-between mt-1">
                        <span className="text-xs text-gray-500">
                          {comune.zona}
                        </span>
                        <span className="text-xs text-gray-400">
                          {comune.distanza}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <i className="ri-map-pin-line text-6xl text-gray-300 mb-4"></i>
                  <p className="text-gray-500">
                    Nessun comune trovato per &quot;{searchTerm}&quot;
                  </p>
                  <p className="text-sm text-gray-400 mt-2">
                    Prova con un altro termine di ricerca
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      {/* Info Section */}
      <section className="py-10 md:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white rounded-xl p-5 md:p-6 shadow-sm border border-gray-100">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#E31E24]/10 flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-truck-line text-[#E31E24] text-xl md:text-2xl"></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2">
                Servizio a Domicilio
              </h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                Parto da Paderno Franciacorta e <strong>vengo direttamente da te</strong> entro 30 km. Lavoro nel tuo garage, parcheggio o cortile con tutta l'attrezzatura necessaria.
              </p>
            </div>
            <div className="bg-white rounded-xl p-5 md:p-6 shadow-sm border border-gray-100">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#E31E24]/10 flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-time-line text-[#E31E24] text-xl md:text-2xl"></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2">
                Orari Flessibili
              </h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                Disponibile dal lunedì al venerdì 8:00-19:00 e sabato 8:00-13:00.
                Prenota l&apos;orario più comodo per te.
              </p>
            </div>
            <div className="bg-white rounded-xl p-5 md:p-6 shadow-sm border border-gray-100">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#E31E24]/10 flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-phone-line text-[#E31E24] text-xl md:text-2xl"></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2">
                Contattami Subito
              </h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed mb-4">
                Chiamami o scrivimi su WhatsApp per prenotare il tuo intervento.
              </p>
              <div className="flex flex-col sm:flex-row gap-2">
                <a
                  href="tel:+393518312394"
                  className="inline-flex items-center justify-center px-4 py-2.5 bg-[#E31E24] text-white font-semibold rounded-lg hover:bg-[#c41a1f] transition-all duration-300 cursor-pointer whitespace-nowrap text-xs sm:text-sm"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Chiamami
                </a>
                <a
                  href="https://wa.me/393518312394"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-4 py-2.5 bg-white text-black font-semibold rounded-lg border border-gray-200 hover:bg-gray-50 transition-all duration-300 cursor-pointer whitespace-nowrap text-xs sm:text-sm"
                >
                  <i className="ri-whatsapp-line mr-2 text-[#25D366]"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-10 md:py-16 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 md:mb-4">
            Il tuo comune non è in lista?
          </h2>
          <p className="text-white/80 text-sm sm:text-base md:text-lg mb-6 md:mb-8">
            Contattami comunque! Posso valutare di raggiungerti anche oltre i
            30 km da Paderno Franciacorta. <strong>Il meccanico viene da te</strong>, ovunque tu sia.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4">
            <a
              href="tel:+393518312394"
              className="inline-flex items-center justify-center px-6 md:px-8 py-3 md:py-4 bg-[#E31E24] text-white font-semibold rounded-lg hover:bg-[#c41a1f] transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-phone-line mr-2"></i>
              +39 351 831 2394
            </a>
            <a
              href="https://wa.me/393518312394"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 md:px-8 py-3 md:py-4 bg-white text-black font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-whatsapp-line mr-2 text-[#25D366]"></i>
              Scrivimi su WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
